import React from 'react';
import oops from "../img/oops.png";
import "../css/common.scss";

export default function DenialPage() {
    const styles = {
        container: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          textAlign: "center",
          padding: "20px",
        },
       
        link: {
          marginTop: "2rem",
          padding: "0.75rem 1.5rem",
          fontSize: "1rem",
          backgroundColor: "#d7172f",
          color: "#fff",
          textDecoration: "none",
          borderRadius: "0.5rem",
          transition: "background-color 0.3s ease",
        },
        linkHover: {
          backgroundColor: "#0056b3",
        },
      };
    
      return (
        <div class="danial-page" style={styles.container}>
          <div className="denial-icon">
            <img src={oops} alt="Oops" />
          </div>
          <h1>404</h1>
          <p>Oops! The page you're looking for doesn't exist.</p>
          {/*<a
            href="/"
            style={styles.link}
            onMouseEnter={(e) => (e.target.style.backgroundColor = styles.linkHover.backgroundColor)}
            onMouseLeave={(e) => (e.target.style.backgroundColor = styles.link.backgroundColor)}
          >
            Go Back Home
          </a>*/}
        </div>
      );
}
